import Icon from '@components/v2/ui/Icon/Icon';
import { useTranslation } from '../../../../translation/TranslationContext';
import HighlightedText from '../../../components/HighlightedText';
import ResultRowBase from '../../../components/ResultRow/ResultRowBase';
import { StaticCommand } from '../../staticCommands.types';

interface CommandRowProps {
  command: StaticCommand;
  query: string;
  isActive?: boolean;
  domId?: string;
  onSelect: () => void;
}

const CommandRow = ({ command, query, isActive, domId, onSelect }: CommandRowProps) => {
  const { translate } = useTranslation();
  const label = translate(command.labelKey);

  return (
    <ResultRowBase
      testId={`global-search-command-${command.id}`}
      isActive={isActive}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={command.icon} size="md" />}
      title={<HighlightedText text={label} query={query} />}
    />
  );
};

export default CommandRow;
